import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D288 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D288 - Back-End Programming</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 12.92 hrs</h4>
        <hr />
        <div className="card-body">
          <p>Very fun course. Learned a lot of coding here.</p>
          <p>
            These two guides are godly, and they’re all you need:
            <br /> 👉 <a href="https://www.reddit.com/r/WGU_CompSci/comments/168qz83/d288_backend_programming_guide/" target="_blank" rel="noreferrer">D288 Backend Programming Guide</a> <br />
            👉 <a href="https://www.reddit.com/r/WGU_CompSci/comments/1g2bi3w/d288_backend_programming_2024_guide/" target="_blank" rel="noreferrer">D288 Backend Programming 2024 Guide</a>
          </p>
          <p>
          Other problems I ran into that aren’t mentioned in the guides:
          <ol>
            <li>My frontend wouldn’t populate, and after a million checks on my variables, I realized I had to make getters and setters for everything. Lombok doesn’t work anymore.</li>
            <li>My vacation price type didn’t match my price variable type in excursions, so it was glitching. Make sure they’re the same type.</li>
          </ol>
          </p>
          <p>
          TL;DR: Follow the guides, fix your getters/setters, and double-check your variable types. 🚀
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D288;
